import {Injectable} from '@angular/core';
import {GenericRoteirizadorService} from 'src/app/core/services';
import {MensagensService} from 'max-ng-lib';
import {HttpClient} from '@angular/common/http';

@Injectable({providedIn: 'root'})
export class JanelaEntregaService extends GenericRoteirizadorService {

  constructor(
    private mensagensService: MensagensService,
    private httpClient: HttpClient
  ) {
    super();
  }

  getMensagensService(): MensagensService {
    return this.mensagensService;
  }

  getHttpClient(): HttpClient {
    return this.httpClient;
  }

  getUrlRecurso(): string {
    return '/janelasEntregas';
  }

  diasDaSemana() {
    return this.get<any[]>('/diasDaSemana');
  }

  salvar(janelasEntrega) {
    return this.post<any>('/salvarJanelas', { dados: janelasEntrega });
  }


  listarPorClienteAndEndereco(value: any) {
    return this.get<any[]>('/listarPorClienteAndEndereco', {
      dados: value,
      exibirLoading: false
    });
  }

  removerJanelaEntrega(value: any[]) {
    return this.delete(`/excluir/${value}`);
  }

  obterPorIdClienteAndIdEnderecoAndDiaSemana(idCliente, idClienteEndereco, dataInicio) {
    const dados = {
      idCliente,
      dataInicio,
      idClienteEndereco
    };
    if (!idClienteEndereco) {
      delete dados.idClienteEndereco;
    }
    return this.get<any[]>('/obterPorIdClienteAndIdEnderecoAndDiaSemana', {
      dados
    });
  }

  existeJanelaNoCarregamento(idCarregamento: string) {
    const dados = {idCarregamento};
    return this.get<any>(`/existeJanelaNoCarregamento`, {
      dados
    });
  }
}
